import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Footer from "./Footer";
import "./Login.css";
import {BASE_URL} from "./Constants";

const Login = () => {
  const navigate = useNavigate();
  const [isSignup, setIsSignup] = useState(false); 
  const [step, setStep] = useState(1);

  // form states
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState();

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSentOtp = async () => {
    if (!formData.email) {
      setMessage("Please enter your email")
      return
    }

    // email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(formData.email)) {
        setMessage("Please enter a valid email")
        return
    }

    try {
      const res = await fetch(`${BASE_URL}/send_otp`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, context: "signup" }),  //new context field to specify signup OTP
              
      });

      const data = await res.json()

      // ✅ Handle error from backend
      if (!res.ok || data.status === "error") {
            setMessage(data.message || "Failed to send OTP")
            return
      }
      setMessage("OTP sent to your email!")
      setStep(2);
    } catch {
      setMessage("Error sending OTP")
      setMessageType("error")
    }
  };

  const handleVerifyOtp = async () => {
    if (!formData.otp){
      setMessage("Please enter OTP")
      return
    }

    try {
      const res = await fetch(`${BASE_URL}/validate_otp`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, otp: formData.otp }),
      });
      if (!res.ok) throw new Error("Invalid OTP");
      setMessage("OTP Verified! Now set your password.")
      setStep(3);
    } catch {
      setMessage("Invalid OTP")
    }
  };

  const handleSignup = async () => {
    if (!formData.email || !formData.password || !formData.otp) {
      setMessage("Please complete all steps (email, OTP, password)")
      return
    }

    try {
      const res = await fetch(`${BASE_URL}/signup`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email,
          password: btoa(formData.password), // Base64 encode the password
          otp: formData.otp,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Signup failed");

      setMessage("Signup successful! You can now log in.")
      setIsSignup(false);
      setStep(1);
    } catch (err) {
      setMessage(err.message || "Signup error")
    }
  };


  const handleLogin = async () => {
    if (!formData.email || !formData.password) {
        setMessage("Enter email and password")
        return;
    }

    //email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(formData.email)) {
        setMessage("Please enter a valid email and password")
        return
    }
    try {
      const encodedPassword = btoa(formData.password);
      const res = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
                email:    formData.email,
                password: encodedPassword 
            }),
        credentials: "include"
      });
      const data = await res.json();
      if (!res.ok || data.error) throw new Error(data.error || "Login failed");

      setMessage("Login successful!")
      navigate("/"); // pass user info
    } catch (err) {
      setMessage(err.message || "Login error")
    }
  };

    const handleGoogleLogin = () => {
        window.location.href = `${BASE_URL}/oauth/google/login`;
    };


  return (
    <>
      <div className="checkout-login-container">
        <h2 className="checkout-title">{isSignup ? "Sign Up" : "Login"}</h2>

        <div className="checkout-login-box">
          <div className="login-left">
            <p>New to SR? or Existing user</p>
            <button
              className="signup-btn"
              onClick={() => {
                setIsSignup(true);
                setStep(1);
                setFormData({ email: "", otp: "", password: "" });
              }}
            >
              New here? Sign Up
            </button>
            <button
              className="existing-btn"
              onClick={() => {
                setIsSignup(false);
                setStep(1);
                setFormData({ email: "", otp: "", password: "" });
              }}
            >
              Existing? Login
            </button>
          </div>

          <div className="login-right">
            {!isSignup ? (
              <>
                <h3>Login</h3>
                <div className="login-form">
                  <input
                    type="text"
                    name="email"
                    placeholder="📧 Enter email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />

                  {message && (
                    <p className={`msg ${messageType}`}>{message}</p>
                  )}

                  <div className="password-container">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="🔒 Enter password"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                    <span
                      className="eye-icon"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>

                  {message &&  (
                    <p className={`msg ${messageType}`}>{message}</p>
                  )}

                  <button className="login-btn" onClick={handleLogin}>
                    Log In
                  </button>
                  <p
                    className="forgot-password"
                    onClick={() => navigate("/forgot-password")}
                  >
                    Forgot password?
                  </p>

                  <h3 className="divider">OR</h3>
                      <button className="google-btn" onClick={handleGoogleLogin}>
                      <img className="google-image" src="/assets/google-icon.png" alt="google" />
                        <b>Continue with Google</b>
                      </button>
                </div>
              </>
            ) : (
              <>
                <h3>Sign Up</h3>
                <div className="login-form">
                  {step === 1 && (
                    <>
                      <input
                        type="text"
                        name="email"
                        placeholder="📧 Enter email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />

                      {message &&  (
                        <p className={`msg ${messageType}`}>{message}</p>
                      )}

                      <button className="otp-btn" onClick={handleSentOtp}>
                        Get OTP
                      </button>
                      <h3 className="divider">OR</h3>
                      <button className="google-btn" onClick={handleGoogleLogin}>
                      <img className="google-image" src="/assets/google-icon.png" alt="google" />
                        <b>Continue with Google</b>
                      </button>
                    </>
                  )}

                  {step === 2 && (
                    <>
                      <input
                        type="text"
                        name="otp"
                        placeholder="🔢 Enter OTP"
                        value={formData.otp}
                        onChange={handleInputChange}
                      />

                      {message &&  (
                        <p className={`msg ${messageType}`}>{message}</p>
                      )}

                      <button className="otp-btn" onClick={handleVerifyOtp}>
                        Verify OTP
                      </button>
                    </>
                  )}

                  {step === 3 && (
                    <div className="password-signup-container">
                      <input 
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="🔒 Enter password"
                        value={formData.password}
                        onChange={handleInputChange}
                      />
                      <span
                        className="eye-icon-signup"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>

                      {message &&(
                        <p className={`msg ${messageType}`}>{message}</p>
                      )}

                      <button className="signup-btn" onClick={handleSignup}>
                        Sign Up
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;